import script from "./UserNote.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNote.vue?vue&type=script&setup=true&lang=js"

import "./UserNote.vue?vue&type=style&index=0&id=bfab80b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfab80b8"]])

export default __exports__